import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdEdit, MdSearch } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { invoiceId } = useParams();

  return (
    <Layout
      {...props}
      invoiceElements={
        invoiceId && (
          <Fragment>
            <NavListSectionHeader>Invoice CI-{invoiceId}</NavListSectionHeader>
            <NavLink end to={`/billing/invoice/${invoiceId}`}>
              <NavListItem icon={MdSearch}>Preview & Send</NavListItem>
            </NavLink>
            <NavLink to={`/billing/invoice/${invoiceId}/edit`}>
              <NavListItem icon={MdEdit}>Edit</NavListItem>
            </NavLink>
          </Fragment>
        )
      }
    />
  );
}
